const API = process.env.REACT_APP_API_URL || 'https://api.intrlock.io';

function authHeaders(): HeadersInit {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('intrlock_token') ?? ''}`,
  };
}

export interface OnvifCreds {
  host: string;
  username: string;
  password: string;
  port?: string;
  rtsp_port?: string;
  service_path?: string;
}

export interface OnvifProfile {
  profile_token: string;
  name: string | null;
  encoding: string | null;
  resolution: string | null;
  framerate: number | null;
}

export interface ProbeResult {
  device_info: { manufacturer?: string; model?: string; firmware_version?: string; serial_number?: string } | null;
  profiles: OnvifProfile[];
  error: string | null;
}

export async function probeCamera(creds: OnvifCreds): Promise<ProbeResult> {
  const res = await fetch(`${API}/cameras/probe`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(creds),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `probe ${res.status}`);
  return res.json();
}

export interface CreateCameraInput {
  property_id: string;
  name: string;
  profile_token: string;
  onvif: OnvifCreds;
  ingress?: { mode: 'URL_INPUT' | 'WHIP_INPUT' | 'RTMP_INPUT'; public_rtsp_url?: string };
}

export async function createCamera(input: CreateCameraInput): Promise<{ device: any; ingress: any }> {
  const res = await fetch(`${API}/cameras`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `create ${res.status}`);
  return res.json();
}

export async function getCameraViewerToken(deviceId: string, ttl = 3600): Promise<{ token: string; livekit_host: string; room_name: string }> {
  const res = await fetch(`${API}/cameras/${deviceId}/viewer-token`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify({ ttl }),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `token ${res.status}`);
  return res.json();
}

export async function deleteCamera(deviceId: string): Promise<void> {
  const res = await fetch(`${API}/cameras/${deviceId}`, { method: 'DELETE', headers: authHeaders() });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `delete ${res.status}`);
}
